var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"how-to-play-wrapper"},[_c('div',{ref:"htpContainer",staticClass:"how-to-play-container"},[_c('canvas',{ref:"howToPlay",staticClass:"how-to-play-canvas"})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b86d02c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/components/arcade-game/_components/how-to-play/how-to-play.html
// module id = null
// module chunks = 